import { type ReactNode, useEffect, useState } from 'react';

export const isBrowser = typeof document !== 'undefined';

let hydrating = true;

function useHydrated(): boolean {
	const [hydrated, setHydrated] = useState(() => !hydrating);

	useEffect(() => {
		hydrating = false;
		setHydrated(true);
	}, []);

	return hydrated;
}

interface ClientOnlyProps {
	children(): ReactNode;
	fallback?: ReactNode;
}

export function ClientOnly({ children, fallback = null }: Readonly<ClientOnlyProps>) {
	return useHydrated() ? children() : fallback;
}
